// language extension to hljs for Optima++ keywords
module.exports = function (hljs) {
  return {
    keywords: {
      keyword: "USE_NAME MECH_FILE COMPILE_FM MECHANISM THREAD_LIMIT SOLVER NAME",
      literal: "FM OS abs absln",
      attribute: "SIGM SIGMSCALE"
    },
    contains: [
      hljs.COMMENT('!', /$/),
      {
        className: 'block',
        beginKeywords: 'MECHMOD MECHTEST END',
      },
      {
        className: 'string',
        begin: /(\w|\.)+\/(\w|\.)+/
      },
      {
        className: 'number',
        begin: '\\s(-)?\\b\\d+(\\.\\d+)?',
      },

    ]
  }
}